// Copy of the "Materials" walkthrough. The rules every text follows are in ../../de/help.js.
// Tab and field names are written as the material page shows them (../material.js).
// Twin file: help/machines.js. A change here nearly always belongs there too.
export default {
  title: "Materials",
  // Short names of the views, for the header, the timeline and "Continue to …".
  section: {
    MaterialOverview: "Overview",
    MaterialDetail: "Material",
    CustomerDetail: "Customer prices",
    PacketDetail: "Packet",
    ProjectDetail: "Project",
    ProjectCostsForOne: "Project costs",
  },
  related: "Connections",
  step: {
    list: {
      text: "This is your company's material catalogue. A click on a row opens that material.",
    },
    row: {
      text: "A row shows the name, the purchase price per unit and when the material was last changed.",
    },
    create: {
      text: "Create new offers both: create new material opens the empty form. It needs a name and a unit.",
    },
    "kind-filter": {
      text: "Materials and packets share one table, and the filter above it shows just one of the two. A packet bundles several materials for a project or a customer.",
    },
    head: {
      text: "The head carries the material's icon and its name. The actions for this record sit on the right.",
    },
    "action-duplicate": {
      text: "Duplicate opens a new material with the same details and prices. You change only what differs and save.",
    },
    "action-packet": {
      text: "Create packet from this starts a new packet. This material is already its first position.",
    },
    tabs: {
      text: "The tabs divide the page up. Which tab is open is part of the page's address.",
    },
    base: {
      text: "The name and the unit are the master data. The unit counts in projects and packets, for quantities already recorded too.",
    },
    purchase: {
      text: "The purchase price is per unit. If you pay different suppliers different amounts, add several named purchase prices; one of them is the default. Each price picks its own currency, and a project only costs the price in its own currency.",
    },
    note: {
      text: "The note is for an internal remark. It belongs to the material, not to a single project.",
    },
    // The Purchasing tab, once purchase prices belong to suppliers (docs/suppliers.md).
    "purchase-tab": {
      text: "The Purchasing tab lists every supplier that carries this material. You change their prices at the supplier, in its assortment.",
    },
    "purchase-history": {
      text: "The head says what the material usually costs: the default supplier's price and the range across all. Opened, the price history shows every price over the months, right of Today those already set.",
    },
    "purchase-rows": {
      text: "Each supplier shows today's price and, where already set, the next one. Difference measures it against the default, and the name opens the supplier's assortment.",
    },
    "purchase-default": {
      text: "The default is the price a project takes the material over with. A click on another supplier makes it the default, at once and without saving.",
    },
    "purchase-change": {
      text: "The pencil changes a supplier's price: the new amount, the tiers and the day it applies from, back-dated too. The old price stays in the history.",
    },
    "purchase-quantity": {
      text: "With a quantity to compare at, the Delivered column works in tier prices, discount, freight and early payment discount. With “Pickup” the freight drops out and the column reads Ex yard. The cheapest is bold and green, even when its list price is higher.",
    },
    "purchase-add": {
      text: "Add price takes on another supplier's price. The first one becomes the default.",
    },
    "purchase-object-prices": {
      text: "Under a supplier are the projects that have a project price with it.",
    },
    "purchase-following": {
      text: "After a backdated change, the projects' bookings stay at the old price. Update puts them on the price of their day.",
    },
    files: {
      text: "File storage is for data sheets and inspection reports. A due date changes colour as it comes closer.",
    },
    activity: {
      text: "Activity shows every change with its day and who made it. Under References you see where this material is used.",
    },
    save: {
      text: "Save writes every tab at once. A tab with an error in it is brought to the front.",
    },
    comparison: {
      text: "Actions, then Compare, sets two materials side by side. The rows are the suppliers that carry both. The cheaper price is bold and green.",
    },
    "comparison-pick": {
      text: "At the top of each card you choose the material. Below, its usual price and at how many suppliers it is the cheaper one.",
    },
    "comparison-only": {
      text: "Suppliers that carry only one of the two are folded under its card.",
    },
    again: {
      text: "This button is on every page that has an explanation. One click starts it again.",
    },
    // Setup: what a material does outside the catalogue.
    "customer-price": {
      text: "For one customer you set a selling price of its own, either fixed or as a surcharge on the purchase price kept here.",
    },
    "packet-items": {
      text: "A packet bundles several materials. A project or a customer takes them all over in one step.",
    },
    "project-materials": {
      text: "Every booking fixes its purchase price. Project costs are quantity times that price.",
    },
    "project-report": {
      text: "A material is booked on the Materials tab of [[hwr:a/an]] [[hwr]], with a quantity for that day. Only what the project carries can be picked there.",
    },
    "project-costs": {
      text: "A project's cost structure shows what share of its cost is material. Every booked quantity is valued at the purchase price fixed when its report was saved.",
    },
  },
}
